import React, { memo } from 'react';
import { ScrollView, Text, TouchableOpacity } from 'react-native';
import { useTheme } from 'styled-components/native';
import {
  useAIAssistantActions,
  useAIAssistantState,
} from '../AIAssistantProvider';
import { SkeletonPill } from './SkeletonPill';
import { useStyles } from './styles';

export const SuggestionBar = memo(function SuggestionBar() {
  const theme = useTheme();
  const state = useAIAssistantState();
  const actions = useAIAssistantActions();
  const styles = useStyles();
  const accentColor = theme.link;

  if (state.isStreaming) return null;

  if (state.isSuggestionsLoading) {
    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={{ flexGrow: 0 }}
        contentContainerStyle={styles.suggestionBar}
      >
        {[100, 130, 90].map((w, i) => (
          <SkeletonPill key={i} width={w} height={28} />
        ))}
      </ScrollView>
    );
  }

  const suggestions =
    state.suggestions.length > 0 ? state.suggestions.map(s => s.text) : [];

  if (suggestions.length === 0) return null;

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      keyboardShouldPersistTaps="handled"
      style={{ flexGrow: 0 }}
      contentContainerStyle={styles.suggestionBar}
    >
      {suggestions.map((q, i) => (
        <TouchableOpacity
          key={i}
          activeOpacity={0.7}
          onPress={() => actions.sendMessage(q)}
          style={[
            styles.suggestionBarChip,
            { borderColor: accentColor + '25' },
          ]}
        >
          <Text
            style={[styles.suggestionBarText, { color: accentColor }]}
            numberOfLines={1}
          >
            {q}
          </Text>
        </TouchableOpacity>
      ))}
    </ScrollView>
  );
});
